export default __webpack_public_path__ + "static/media/Elder Wand - Img - Wip 1_00.02810ad2.jpg";